module.exports = __webpack_public_path__ + "static/media/7.cfb1f4b9.jpg";